angular.module('gym.membership-plans').controller('MembershipPlanCategoryManagementCtrl', ["$rootScope", "$scope", "$modalInstance", "$http", "MembershipPlanCategories", function($rootScope, $scope, $modalInstance, $http, MembershipPlanCategories) {
  var categoryAdded, categoryDeleted, categoryEdited, getIncomeCategories, gym, reload;
  gym = $rootScope.gym;
  $scope.newCategory = {};
  categoryAdded = false;
  categoryDeleted = false;
  categoryEdited = false;
  getIncomeCategories = function() {
    var params, url;
    url = `/gyms/${gym.id}/accounting_codes`;
    params = {
      count: 1000,
      'filters[category]': 'for_membership'
    };
    return $http.get(url, {
      params: params
    }).then(function(response) {
      return $scope.incomeCategories = response.data.collection;
    });
  };
  getIncomeCategories();
  $scope.getIncomeCategoryLabel = function(category) {
    return `Income category: ${category.name} [${category.code}]`;
  };
  reload = function() {
    return MembershipPlanCategories.getList({
      count: 200
    }).then(function(data) {
      return $scope.categories = data;
    });
  };
  $scope.categories = [];
  reload();
  $scope.create = function() {
    $scope.isLoading = true;
    return MembershipPlanCategories.post($scope.newCategory).then(function(newCategory) {
      $scope.isLoading = false;
      $scope.newCategory = {};
      categoryAdded = true;
      return $scope.categories.push(newCategory);
    });
  };
  $scope.save = function(category) {
    return category.save().then(function(data) {
      categoryEdited = true;
      category._edit = false;
      return $scope.error = void 0;
    }, function(error) {
      return $scope.error = 'Error saving category.';
    });
  };
  $scope.delete = function(category) {
    if (window.confirm('Are you sure?')) {
      return category.remove().then(function(data) {
        var index;
        categoryDeleted = true;
        index = $scope.categories.indexOf(category);
        if (index > -1) {
          $scope.categories.splice(index, 1);
        }
        return $scope.error = void 0;
      }, function(error) {
        return $scope.error = 'This category is in use and cannot be deleted at this time.';
      });
    }
  };
  return $scope.close = function() {
    if (categoryAdded || categoryDeleted || categoryEdited) {
      $rootScope.$broadcast('membershipPlanCategories:changed');
    }
    return $modalInstance.close();
  };
}]);
